// extracted by mini-css-extract-plugin
export var center = "_t-2";
export var clickableRow = "_t-5";
export var expandedRow = "_t-7";
export var hoverable = "_t-4";
export var left = "_t-1";
export var right = "_t-3";
export var row = "_t-0";
export var selectedRow = "_t-6";
export var summaryRow = "_t-8";